import { FC, ReactNode, SVGProps } from 'react'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { LucideIcon } from 'lucide-react'

type SettingsCardProps = {
  Icon?: LucideIcon | FC<SVGProps<SVGSVGElement> & { color?: string }>
  title: string
  description?: ReactNode
  sections: ReactNode[]
  footer?: ReactNode
  className?: string
}

const SettingsCard: FC<SettingsCardProps> = ({ Icon, title, description, sections, footer, className = '' }) => (
  <Card className={`w-lg overflow-visible ${className}`}>
    <CardHeader>
      <CardTitle className="flex items-center gap-3">
        {Icon && <Icon className="w-5 h-5" />}
        {title}
      </CardTitle>
      {description && <CardDescription>{description}</CardDescription>}
    </CardHeader>
    <Separator />
    <CardContent className="grid gap-8 pt-6 overflow-visible">
      {sections.map((section, idx) => (
        <section key={idx} className="overflow-x-auto">
          {section}
        </section>
      ))}
    </CardContent>
    {footer && <CardFooter>{footer}</CardFooter>}
  </Card>
)

export default SettingsCard
